import { render, staticRenderFns } from "./ImageGroupDetails.vue?vue&type=template&id=e28a2096&scoped=true&"
import script from "./ImageGroupDetails.vue?vue&type=script&lang=js&"
export * from "./ImageGroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./ImageGroupDetails.vue?vue&type=style&index=0&id=e28a2096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a2096",
  null
  
)

export default component.exports